import { render, staticRenderFns } from "./w-image-cropper.vue?vue&type=template&id=84b83f84"
import script from "./w-image-cropper.vue?vue&type=script&lang=js"
export * from "./w-image-cropper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports